/**
 * Wire protocol between the Omni shell (parent window) and an app running
 * in a sandboxed iframe. Both sides import these types.
 */
export const PROTOCOL = "omni/1";
/** `finance.*` style matching, the same as the server's. */
export function eventMatches(patterns, type) {
    return patterns.some((p) => new RegExp(`^${p.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*")}$`).test(type));
}
export function isOmniMessage(value) {
    return typeof value === "object" && value !== null && value.protocol === PROTOCOL;
}
